var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shadow-lg p-3 mb-5 bg-white rounded"},[_c('Header',{attrs:{"titulo":_vm.Titulo}}),_c('Contenedor',{attrs:{"tipo":_vm.Tipo,"titulo":_vm.Titulo,"estado":_vm.Estado}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }